module.exports = __webpack_public_path__ + "static/tyne-bridge-1064d351c20aba1348d3810dd22b6759.jpg";